import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Layout } from "antd";
import { HelmetProvider } from 'react-helmet-async';
import "./Style/GlobalFonts.css";

import Navbar from "./Componant/Navbar";
import Footer from "./Componant/Footer";
import ScrollToTop from "./ScrollToTop/ScrollToTop";
import ServiceSection from "./Componant/ServiceSection";
import AIMLDevelopment from "./Componant/pages/services/allServices/AIMLDevelopment";
import DataScience from "./Componant/pages/services/allServices/DataScience";
import SitemapGenerator from "./components/SitemapGenerator";
import RedirectHandler from "./components/RedirectHandler";
import GoogleAnalytics from "./components/SEO/GoogleAnalytics";



import TestPage from "./TestPage";

// Lazy-loaded components
const MainSection = React.lazy(() => import("./Componant/MainSection"));
const WebDevelopment = React.lazy(() =>
  import("./Componant/pages/services/allServices/WebDevlopment")
);
const MobileDevelopment = React.lazy(() =>
  import("./Componant/pages/services/allServices/MobileDevelopment")
);
const CloudService = React.lazy(() =>
  import("./Componant/pages/services/allServices/CloudService")
);
const ProductDevelopment = React.lazy(() =>
  import("./Componant/pages/services/allServices/ProductDevelopment")
);
const HwswIntigration = React.lazy(() =>
  import("./Componant/pages/services/allServices/HwswIntigration")
);
const StaffingSolution = React.lazy(() =>
  import("./Componant/pages/services/allServices/StaffingSolution")
);
const UiDesign = React.lazy(() =>
  import("./Componant/pages/services/allServices/UiDesign")
);
const IotDevelopment = React.lazy(() =>
  import("./Componant/pages/services/allServices/IotDevelopment")
);
const VerticalSlider = React.lazy(() =>
  import("./Componant/pages/VerticalSlider")
);
const AboutUs = React.lazy(() => import("./Componant/pages/Aboutus"));
const CareerPage = React.lazy(() => import("./Componant/pages/Career"));
const BlogSection = React.lazy(() =>
  import("./Componant/pages/Blog/BlogSection")
);
const OurWork = React.lazy(() =>
  import("./Componant/pages/OurWork/OurWork")
);
const ExpertiseDetail = React.lazy(() =>
  import("./Componant/pages/ExpertiesPage/ExpertiseDetail")
);
const ContactUs = React.lazy(() =>
  import("./Componant/pages/ContactUs/ContactUs")
);
const BlogDetail = React.lazy(() =>
  import("./Componant/pages/Blog/BlogDetail")
);
const Chaat = React.lazy(() =>
  import("./Componant/pages/Chaat")
);

// Mobile-optimized fallback component
const Fallback = () => (
  <div style={{ 
    textAlign: "center", 
    padding: "40px 20px",
    minHeight: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  }}>
    <div style={{
      width: "40px",
      height: "40px",
      border: "3px solid #f3f3f3",
      borderTop: "3px solid #1890ff",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
      marginBottom: "15px"
    }}></div>
    <p style={{ margin: 0, fontSize: "1rem", color: "#666" }}>Loading...</p>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

const { Header, Content } = Layout;
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <GoogleAnalytics trackingId={GA_MEASUREMENT_ID} />
        <ScrollToTop />
        <RedirectHandler />
        <Layout style={{ minHeight: "100vh" }}>
        <Navbar />
        <Content style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<MainSection />} />
              <Route path="/web-development" element={<WebDevelopment />} />
              <Route
                path="/mobile-development"
                element={<MobileDevelopment />}
              />
              <Route path="/cloud-services" element={<CloudService />} />
              <Route
                path="/product-development"
                element={<ProductDevelopment />}
              />
              <Route path="/hw-sw-integration" element={<HwswIntigration />} />
              <Route path="/ai-ml-development" element={<AIMLDevelopment />} />
              <Route path="/staffing-solution" element={<StaffingSolution />} />
              <Route path="/ui-design" element={<UiDesign />} />
              <Route path="/data-science" element={<DataScience />} />
              <Route path="/iot-development" element={<IotDevelopment />} />
              <Route path="/our-work" element={<OurWork />} />
              <Route path="/blog" element={<BlogSection />} />
              <Route path="/blog/:slug" element={<BlogSection />} />

              <Route path="/about" element={<AboutUs />} />
              <Route path="/career" element={<CareerPage />} />
              <Route path="/expertise/:tech" element={<ExpertiseDetail />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/blog-detail/:id" element={<BlogDetail />} />
              <Route path="/service-section" element={<ServiceSection />} />
              <Route path="/sitemap-generator" element={<SitemapGenerator />} />
              <Route path="/chaat" element={<Chaat />} />
            <Route path="/test" element={<TestPage />} />
            </Routes>
        </Content>
        </Layout>
        <Footer />
      </Router>
    </HelmetProvider>
  );
};

export default App;
